'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ELEMENT_COUNT_INCREAESE = exports.ELEMENT_COUNT_INCREAESE = 'ELEMENT_COUNT_INCREAESE';
var ELEMENT_COUNT_DECREASE = exports.ELEMENT_COUNT_DECREASE = 'ELEMENT_COUNT_DECREASE';

var ELEMENT_COUNT_WARNING_START = exports.ELEMENT_COUNT_WARNING_START = 20;
var ELEMENT_COUNT_WARNING_INTERVAL = exports.ELEMENT_COUNT_WARNING_INTERVAL = 10;

var ELEMENT_COUNT_LIMIT_POPUP = exports.ELEMENT_COUNT_LIMIT_POPUP = 'billing-alert';


//////////////////
// WEBPACK FOOTER
// ./src/client/user/elementCount/elementCountConstants.js
// module id = 169
// module chunks = 0